import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@roc/feature-app-core';
import { DialogState } from '@roc/ui';
import { makeStyles } from '@material-ui/core';
import { GeneralTaskType } from '../../types/generalTasksTypes';
import { AddLoanTaskDialog } from './addLoanTaskDialog';
import { LoanProcess, capitalize } from '@roc/feature-utils';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
}));

const decodeData = (encodedData: string) => {
  if (!encodedData) {
    return null;
  }
  try {
    return atob(decodeURIComponent(encodedData));
  } catch (e) {
    return encodedData;
  }
}

export const AddLoanTaskInternalDialog = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const { loanId } = useParams<{ loanId: string }>();
  const query = useQuery();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const options = editTaskStore.loanTaskSectionNames.map(category => ({ value: category.taskCategoryId, label: category.displayName }));
  useStyles();

  useEffect(() => {
    if (query.get('openModal') === 'true') {
      setIsOpen(true);
      editTaskStore.fetchLoanTaskSectionNames(parseFloat(loanId), capitalize(LoanProcess.UNDERWRITING));

      window.parent.postMessage({ action: 'modal-ready' }, '*');
    }
  }, [query, loanId]);

  const handleCloseModal = () => {
    setIsOpen(false);
    window.parent.postMessage({ action: 'close-modal' }, '*');
  }

  return (
    <AddLoanTaskDialog
      open={isOpen}
      loanId={parseFloat(loanId)}
      handleClose={() => handleCloseModal()}
      options={options}
      loanProcess={LoanProcess.UNDERWRITING}
    />
  );
});
